import { ReactNode } from "react";

import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type HistoryEntryLabelProps = {
  children: ReactNode;
  id?: string;
};

const HistoryEntryLabel = ({ children, id }: HistoryEntryLabelProps) => {
  return (
    <Typography id={id} tag="span" variant="p-body3" color="secondary" className={styles.label}>
      {children}
    </Typography>
  );
};

export default HistoryEntryLabel;
